<template>

    <form ref="candidato-form-configurar-acesso" v-on:submit.prevent="executeSave()" novalidate>

        <div class="card" v-if="colaborador">
            <div class="card-body">

                <div class="row mb-2">
                    <div class="col-md-6">
                        <h6 class="card-subtitle text-muted">Nome completo</h6>
                        <h5 class="card-title">{{colaborador.nmCompleto}}</h5>
                    </div>
                    <div class="col-md-6">
                        <h6 class="card-subtitle text-muted">E-mail atual</h6>
                        <h5 class="card-title">{{colaborador.email}}</h5>
                    </div>
                </div>

            </div>
        </div>

        <br />

        <div class="row">
            <div class="form-group col-md-12">
                <label>E-mail</label>
                <input type="email" class="form-control" v-model="novoEmail" placeholder="nome.sobrenome@cna.com.br" required />
            </div>

            <div class="col-md-12">
                <div class="alert alert-info">
                    <p>
                        Antes de finalizar a contratação do candidato, é necessário informar um e-mail que tenha o domínio @cna.com.br. Por exemplo:
                    </p>

                    <p>
                        nome.sobrenome@cna.com.br<br />
                        nome.departamento@cna.com.br
                    </p>

                    <p>
                        O e-mail informado deve ser uma conta válida e já criada. Caso queira criar a conta agora acesse <a href="https://admemail.cna.com.br/login" target="_blank">www.cna.com.br/admemail</a>.
                        Somente o perfil de Franqueado consegue criar novas contas de e-mail para a escola.
                    </p>
                    <p>
                        Após a conta de e-mail estar criada, informe-o acima e clique em salvar. Será encaminhado um link para a conta de e-mail informada.
                    </p>
                    <p>
                        O candidato deverá acessar a conta de e-mail, clicar no link que foi encaminhado na mensagem, preencher a senha de acesso dele e salvar.
                    </p>
                    <p>
                        Após esse processo, o candidato será contratado e passará a ter acesso ao Portal Corporativo e demais sistemas.
                    </p>
                </div>
            </div>
        </div>

        <br />

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>

        <button type="button" class="btn btn-primary float-right" @click="executeSave()">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "candidato-form-configurar-acesso",
        mixins: [base],
        props: { candidatoId: Number },
        data: () => ({
            novoEmail: "",
            colaborador: null,
            form: "candidato-form-configurar-acesso",
        }),

        methods: {

            executeSave: function () {

                if (this.formValidate() == false) return;
                if (!this.novoEmail) return;

                this.showLoading();

                new Api('candidato').put({
                    attributeBehavior: "ConfigurarNovoEmailCandidato",
                    candidatoId: this.candidatoId,
                    colaborador: {
                        email: this.novoEmail
                    }
                }).then(data => {
                    this.defaultSuccessResult("Novo acesso do colaborador configurado com sucesso.");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })

            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            },

        },

        mounted() {

            new Api('colaborador').get({ candidatoId: this.candidatoId }).then(data => {
                this.colaborador = data.dataList[0];
            }, err => { this.defaultErrorResult(err); })

        }
    };
</script>
